<template>
  <v-card :color="color" width="100%" class="flex" tile :height="height" flat tile>
    <v-row no-gutters calss="flex-nowrap">
      <v-col cols="3"></v-col>
      <v-col cols="5" class="subtitle-2 footer-card">
        <span v-for="item in medias">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="clickMediaLink(item)" color="white" v-bind="attrs" v-on="on" small style="margin-right:10px">
                <v-avatar size="24"><img :src="item.icon"></v-avatar>
              </v-btn>
            </template>
            <span>{{ item.name }}</span>
          </v-tooltip>
        </span>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="2">
        <i class="copy-right">{{copyRight }}</i>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
  import CONFIG from '@/config/config.js';

  export default {
    props:{
      color:{
        type: String,
        default:"success"
      },
      height:{
        type:String,
        default:"25px"
      }
    },
    data () {
      return {
        medias:CONFIG.MEDIAS,
        copyRight:CONFIG.COPYRIGHT,
      }
    },
    methods:{
      clickMediaLink(item){
        let url = item.link;
        if (url.startsWith("http")){
          window.open(url, "_blank");
        }else if(url.startsWith("mailto:")){
          window.open(url, "_blank");
        }else{
          this.$router.push({path:url})
        }
      },
    }
  }
</script>
<style lang="stylus" scoped>
.footer-card
  margin-right 10%
.copy-right
  color #ffffff
  font-size  12px
  float  right
  margin-right 10px
</style>